module.exports = __webpack_public_path__ + "img/11.ac0da9d6.png";